import BaseApiClient from "@/api/base-client";
class Index extends BaseApiClient {
    getPipedResponseDef = async (studyId, pipeId) => {
        return this.get(this.getStudyPath(studyId) + `/${pipeId}`);
    };
    getTaskDependents = async (studyId, activityId, taskId) => {
        return this.get(this.getStudyPath(studyId) + `/dependents?activity_id=${activityId}&task_id=${taskId}`);
    };
    save = async (data) => {
        return this.post(this.getStudyPath(data.studyId), { data });
    };
    getResponse = async (studyId, pipeId, userId) => {
        if (userId > 0) {
            return this.get(this.getStudyPath(studyId) + `/${pipeId}/response?user_id=${userId}`);
        }
        return this.get(this.getStudyPath(studyId) + `/${pipeId}/response`);
    };
    getConfig = async (studyId) => {
        return this.get(this.getStudyPath(studyId) + "/config");
    };
    getStudyPath = (studyId) => {
        return `/api/studies/${studyId}/piping`;
    };
    static instance = new Index();
}
export default Index.instance;
